import { type RefObject, useEffect, useRef } from 'react';

/** Keep touch users oriented without opening the software keyboard. */
export function useQuestionFocus(
  inputRef: RefObject<HTMLInputElement | null>,
  textareaRef?: RefObject<HTMLTextAreaElement | null>,
): RefObject<HTMLHeadingElement | null> {
  const headingRef = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    if (window.matchMedia?.('(pointer: fine)').matches === true) {
      (textareaRef?.current ?? inputRef.current)?.focus();
    } else {
      headingRef.current?.focus({ preventScroll: true });
    }
  }, [inputRef, textareaRef]);
  return headingRef;
}
